var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/help-green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invoice-Manager",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents-5",
    transform: "translate(-1189.000000, -96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(387.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/help-line-blue",
    transform: "translate(802.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question-help-circle",
    stroke: "#0083CA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25,12 C23.25,15.1066017 21.9908009,17.9191017 19.9549513,19.9549513 C17.9191017,21.9908009 15.1066017,23.25 12,23.25 C8.89339828,23.25 6.08089828,21.9908009 4.04504871,19.9549513 C2.00919914,17.9191017 0.75,15.1066017 0.75,12 C0.75,8.89339828 2.00919914,6.08089828 4.04504871,4.04504871 C6.08089828,2.00919914 8.89339828,0.75 11.9991888,0.749999561 C15.1046223,0.753358326 17.9156459,2.01334447 19.9511507,4.0488493 C21.9866555,6.08435413 23.2466417,8.89537765 23.25,12 Z",
    id: "Path",
    strokeWidth: 1.5,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "question-help-message-alternate",
    transform: "translate(8.000000, 5.000000)",
    fill: "#0083CA"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 4,
    cy: 12.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0.254 C1.790861,0.254 0,2.044861 0,4.254 C0,4.80628475 0.44771525,5.254 1,5.254 C1.55228475,5.254 2,4.80628475 2,4.254 C1.99998488,3.25510518 2.73698454,2.4093606 3.72649499,2.27275923 C4.71600543,2.13615786 5.6545817,2.75059011 5.92520321,3.71212787 C6.19582472,4.67366562 5.71550222,5.68744207 4.8,6.087 C3.70656854,6.56421259 2.99981923,7.64396849 3,8.837 C3,9.38928475 3.44771525,9.837 4,9.837 C4.55228475,9.837 5,9.38928475 5,8.837 C4.99980714,8.43920185 5.23541191,8.07911923 5.6,7.92 C7.3359457,7.16229297 8.30247173,5.29090433 7.91548522,3.43675524 C7.52849872,1.58260614 5.89410333,0.254 4,0.254 Z",
    id: "Path",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.0896a3b095171e41cf6c0fed914822e0.svg";
export { ForwardRef as ReactComponent };